import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './auth.guard';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: '/auth/start?page=login',
        pathMatch: 'full',
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            }, {
                path: 'components',
                canActivate: [AuthGuard],
                loadChildren: './components/components.module#ComponentsModule'
            }, {
                path: 'template',
                canActivate: [AuthGuard],
                loadChildren: './template/template.module#TemplateModule'
            }, {
                path: 'content',
                canActivate: [AuthGuard],
                loadChildren: './content/content.module#ContentModule'
            }, {
                path: 'contentcreate',
                canActivate: [AuthGuard],
                loadChildren: './create-content/create-content.module#CreateContentModule'
            }, {
                path: 'playlist',
                canActivate: [AuthGuard],
                loadChildren: './playlist/playlist.module#PlaylistModule'
            }, {
                path: 'medialist',
                canActivate: [AuthGuard],
                loadChildren: './media-list/media-list.module#MediaListModule'
            }, {
                path: 'myprofile',
                canActivate: [AuthGuard],
                loadChildren: './my-profile/my-profile.module#MyProfileModule'
            },{
                path: 'change-password',
                canActivate: [AuthGuard],
                loadChildren: './change-password/change-password.module#ChangePasswordModule'
            }, {
                path: 'user',
                canActivate: [AuthGuard],
                loadChildren: './user-list/user-list.module#UserListModule'
            }, {
                path: 'createuser',
                canActivate: [AuthGuard],
                loadChildren: './user-create/user-create.module#UserCreateModule'
            }, {
                path: 'playerlist',
                canActivate: [AuthGuard],
                loadChildren: './player-list/player-list.module#PlayerListModule'
            }, {
                path: 'playerrequest',
                canActivate: [AuthGuard],
                loadChildren: './player-request/player-request.module#PlayerRequestModule'
            }, {
                path: 'groupcreate',
                canActivate: [AuthGuard],
                loadChildren: './player-group-create/player-group-create.module#PlayerGroupCreateModule'
            }, {
                path: 'groupedit',
                canActivate: [AuthGuard],
                loadChildren: './player-group-edit/player-group-edit.module#PlayerGroupEditModule'
            }, {
                path: 'licenserequest',
                canActivate: [AuthGuard],
                loadChildren: './license-request/license-request.module#LicenseRequestModule'
            }, {
                path: 'schedulelist',
                canActivate: [AuthGuard],
                loadChildren: './schedule-list/schedule-list.module#ScheduleListModule'
            }, {
                path: 'schedulecreate',
                canActivate: [AuthGuard],
                loadChildren: './schedule-create/schedule-create.module#ScheduleCreateModule'
            }, {
                path: 'scheduleedit',
                canActivate: [AuthGuard],
                loadChildren: './schedule-edit/schedule-edit.module#ScheduleEditModule'
            }, {
                path: 'createplaylist',
                canActivate: [AuthGuard],
                loadChildren: './playlist-create/playlist-create.module#PlaylistCreateModule'
            }, {
                path: 'editplaylist',
                canActivate: [AuthGuard],
                loadChildren: './playlist-edit/playlist-edit.module#PlaylistEditModule'
            }, {
                path: 'superadmin-client-list',
                canActivate: [AuthGuard],
                loadChildren: './superadmin-client-list/superadmin-client-list.module#SuperadminClientListModule'
            }, {
                path: 'superadmin-client-info',
                canActivate: [AuthGuard],
                loadChildren: './superadmin-client-info/superadmin-client-info.module#SuperadminClientInfoModule'
            }
        ]
    }, {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'auth',
            loadChildren: './pages/pages.module#PagesModule'
        }]
    }
];
